import UnsubscribeAutoReplenCTA from 'components/GlobalModals/UnsubscribeAutoReplenCTA/UnsubscribeAutoReplenCTA';

export default UnsubscribeAutoReplenCTA;
